import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedElement, updateSelectedInteraction } from "../../../app/slices/TrainingSlice";
import { CreateClickRegion, IClickRegion } from "../../../models/interactions/ClickRegion";
import { IClickRegionMultiSelectQuiz } from "../../../models/interactions/ClickRegionMultiSelectQuiz";
import { useTrainingLocalization } from "../../trainingLocalization/TrainingLocalizationHooks";
import QuizPromptPreview from "../QuizPromptPreview";
import ClickRegionPreview from "../click_region/ClickRegionPreview";
import PiBasicQuizAddButton from "../components/PiBasicQuizAddButton";
import "./ClickRegionMultiSelectQuizPreview.css";

export default function ClickRegionMultiSelectQuizPreview() {
  const quiz = useSelector(selectSelectedElement) as IClickRegionMultiSelectQuiz;
  const dispatch = useDispatch();
  const { getValue, changeValue } = useTrainingLocalization();

  const canDelete = quiz.clickregions.length > 2;
  const canAdd = quiz.clickregions.length < 15;

  const onRegionChange = (region: IClickRegion) => {
    var copiedList = [...quiz.clickregions];
    var index = copiedList.indexOf(copiedList.find((cr) => cr.id === region.id)!);
    copiedList[index] = region;

    var copy: IClickRegionMultiSelectQuiz = { ...quiz, clickregions: copiedList };
    dispatch(updateSelectedInteraction(copy));
  };

  const onAddRegion = () => {
    const newRegions: IClickRegion[] = [...quiz.clickregions, CreateClickRegion()];
    const updatedQuiz: IClickRegionMultiSelectQuiz = { ...quiz, clickregions: newRegions };
    dispatch(updateSelectedInteraction(updatedQuiz));
  };

  const onDeleteRegion = (clickregion: IClickRegion) => {
    const updatedRegions = quiz.clickregions.filter((region) => region.id !== clickregion.id);
    const updatedQuiz: IClickRegionMultiSelectQuiz = { ...quiz, clickregions: updatedRegions };
    dispatch(updateSelectedInteraction(updatedQuiz));
  };

  const regions = quiz.clickregions.map((region, index) => {
    return <ClickRegionPreview key={region.id} clickregionProp={region} onChange={onRegionChange} canDelete={canDelete} onDelete={onDeleteRegion} hasCheckbox checked={region.correct} />;
  });

  const title = <QuizPromptPreview onChange={(e) => changeValue(quiz.title, e)} value={getValue(quiz.title)} />;

  const addButton = (
    <div className="clickregionmultiselectquiz-add-button">
      <PiBasicQuizAddButton onClick={onAddRegion} />
    </div>
  );

  return (
    <div className="clickregionmultiselectquiz-root">
      {title}
      {canAdd && addButton}
      {regions}
    </div>
  );
}
